import * as React from "react";
import IconWrapper from "../../../../hiberUiKit/src/atoms/Icon/IconWrapper";
import {Icon} from "../../../../hiberUiKit/src/atoms/Icon/Icon";

interface Props {
	/**
	 * The workspace's action buttons, the same ones shown in a row on a wider screen.
	 */
	renderButton: () => JSX.Element;
}

interface State {
	open: boolean;
}

/**
 * The workspace's actions on a phone: behind one "Actions" button, opening a list of them, rather than a row of
 * buttons wrapping into half the screen above the list.
 */
export default class WorkspaceMobileActions extends React.PureComponent<Props, State> {
	container: HTMLDivElement | null = null;

	constructor(props: Props) {
		super(props);
		this.state = {open: false};
	}

	componentWillUnmount() {
		document.removeEventListener("mousedown", this.onOutsideClick);
	}

	render() {
		return (
			<div className={"c-workspace-mobile-actions"} ref={el => this.container = el}>
				{/* Named and shaped like the Actions menu of the partner brand page, so it reads the same everywhere. */}
				<button type={"button"}
						className={"a-button-primary burgundy c-workspace-mobile-actions_toggle"}
						aria-haspopup={"menu"}
						aria-expanded={this.state.open}
						onClick={this.toggle}>
					<span>Actions</span>
					<IconWrapper icon={Icon.ArrowDown} size={14} variant={"white"}/>
				</button>
				{this.state.open &&
				// A click on any action closes the menu, caught on its way down: the app's buttons stop it bubbling up.
				// The action itself still runs, as its own handler is untouched.
				<div className={"c-workspace-mobile-actions_menu"} role={"menu"} onClickCapture={this.close}>
					{this.props.renderButton()}
				</div>}
			</div>
		);
	}

	toggle = () => this.state.open ? this.close() : this.open();

	open() {
		document.addEventListener("mousedown", this.onOutsideClick);
		this.setState({open: true});
	}

	close = () => {
		document.removeEventListener("mousedown", this.onOutsideClick);
		this.setState({open: false});
	}

	onOutsideClick = (event: MouseEvent) => {
		if (this.container && !this.container.contains(event.target as Node)) {
			this.close();
		}
	}
}
